<template lang="pug"
src='./project-details.pug'>
</template>

<script>
import easyBtn from 'Common/components/easy-btn.vue'
export default {
	name: 'projectDetails',
	components: {
		easyBtn
	},
	props: [
		'project',
		'newConstruct',
		'addition',
		'create',
		'cityChange',
		'btnText'
	]
}
</script>



// WEBPACK FOOTER //
// src/app/project/proj-details.vue